<template>
  <router-view/>
</template>

<style lang="scss">

*,
body {
  font-family: "Lato", "Raleway", "Open Sans", sans-serif;
  color: $color-base;
}

a {
  color: $a-color;
  text-decoration: none;
}

a:hover {
  color: $a-color-hover;
  text-decoration: none;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Lato", "Raleway", "Open Sans", sans-serif;
}

.btn-default,
.btn-default:focus {
  background: $btn-default-bg;
  padding: 15px 50px;
  margin-left: 50px;
  border-radius: 50px;
  color: $btn-default-color;
  font-size: 16px;
  font-weight: bold;
  text-decoration: none;
}

.btn-default:hover,
.btn-default:focus:hover {
  color: $btn-default-color;
  background: $btn-default-bg-hover;
  text-decoration: none;
}

section {
  padding: 60px 0;
  overflow: hidden;
}

.section-title {
  text-align: center;
  padding-bottom: 5px;
}

.section-title p {
  margin: 15px 0 0 0;
}

</style>
